import { formatDateTime } from '../../../../utils/FormatUtils';
import OctTooltip from '../../../../component/tooltip';

export const DANH_SACH_DAT_LICH_HEN_COLUMNS = [
	{
		name: 'Ngày tạo',
		headerStyle: {
			maxWidth: '150px',
		},
		cellStyle: {
			textAlign: 'center',
		},
		render: (rowData: any) => <>{formatDateTime(rowData.createdDate)}</>,
	},
	{
		name: 'Ngày đến khám',
		headerStyle: {
			maxWidth: '150px',
		},
		cellStyle: {
			textAlign: 'center',
		},
		render: (rowData: any) => <>{formatDateTime(rowData.scheduledDate)}</>,
	},
	{
		name: 'Phòng khám',
		headerStyle: {
			maxWidth: '300px',
		},
		render: (rowData: any) => <>{rowData.departmentName}</>,
	},
	{
		name: 'Lý do khám',
		headerStyle: {
			maxWidth: '350px',
		},
		cellStyle: {
			maxWidth: '350px',
			overflow: 'hidden',
			textOverflow: 'ellipsis',
			whiteSpace: 'nowrap',
		},
		render: (rowData: any) => (
			<OctTooltip title={rowData.reason}>
				<span>{rowData.reason}</span>
			</OctTooltip>
		),
	},
	{
		name: 'Trạng thái',
		headerStyle: {
			maxWidth: '150px',
		},
		render: (rowData: any) => <>{rowData.currStatusName}</>,
	},
];

export const APPOINTMENT_STATUS = {
	APPOINTMENT_CANCELED: 'appointment_canceled',
	APPOINTMENT_COMPLETED: 'appointment_completed',
	APPOINTMENT_NEW: 'appointment_new',
	APPOINTMENT_MISSED: 'appointment_missed',
};

export const APPOINMENT_OPTIONS = [
	{
		name: 'Không đến khám',
		value: APPOINTMENT_STATUS.APPOINTMENT_MISSED,
	},
	{
		name: 'Chưa đến khám',
		value: APPOINTMENT_STATUS.APPOINTMENT_NEW,
	},
	{
		name: 'Đã đến khám',
		value: APPOINTMENT_STATUS.APPOINTMENT_COMPLETED,
	},
	{
		name: 'Đã hủy',
		value: APPOINTMENT_STATUS.APPOINTMENT_CANCELED,
	},
];
